import {mapKeys, snakeCase} from 'lodash-es';

import {spotheroGet} from 'api';
import dayjs from 'utils/dayjs';
import {camelizeKeys} from 'utils/format-strings';
import {sendSentryException} from 'utils/error-handling';
import {
    EventTypeOption,
    GetEventTypeOptionsRequest,
} from 'api/events/events.types';
import {apiDateFormat} from 'utils/date-time';

/**
 * Format the response of the Event Types option s.
 */
const formatEventTypeOptionsResponse = (data: EventTypeOption[]) => {
    const formatedData = camelizeKeys(data);

    return formatedData;
};

/**
 * Format the request to get Event Types options.
 */
const formatEventTypeOptionsRequest = (
    data: Pick<GetEventTypeOptionsRequest, 'fromDate' | 'toDate'>
) => {
    const formattedData = mapKeys(data, (value, key) => snakeCase(key));

    return {
        ...formattedData,
        // eslint-disable-next-line camelcase
        from_date: data.fromDate && dayjs(data.fromDate).format(apiDateFormat),
        // eslint-disable-next-line camelcase
        to_date: data.toDate && dayjs(data.toDate).format(apiDateFormat),
    };
};

/**
 * Gets a list of Event Types options for a given facility and date range.
 */
const getEventTypeOptions = async ({
    facilityId,
    fromDate,
    toDate,
}: GetEventTypeOptionsRequest) => {
    try {
        const formattedRequest = formatEventTypeOptionsRequest({
            fromDate,
            toDate,
        });

        const response = await spotheroGet<EventTypeOption[]>(
            `facilities/${facilityId}/event-type-options/`,
            formattedRequest
        );

        const formattedResponse = formatEventTypeOptionsResponse(
            response.data.data.results
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default getEventTypeOptions;
